module.exports = __webpack_public_path__ + "static/media/SarahSwitek_09_EnergyLevel-Conclusion_2.2404322f.mp3";